export function canDisplayEmailSentScreen(state) {
  return !!state.emailSent
}
